/**
 * Defines the watchers related to Primary Navigation bar feature.
 * These watchers will be imported in store/RootSaga.js
 */

import { takeLatest, all } from 'redux-saga/effects';
import * as types from 'constants/ActionTypes';
import {
  getAccessTokenSaga, getNewAccessTokenSaga, addUserInAMPSaga, getUserOnboardingStatusSaga, getCustomAccessTokenSaga, validateUserImpersonationSaga,
  expireGuidSaga,
} from './Authorize.saga';

export default function* watchers() {
  return yield all([
    takeLatest(types.OKTA_TOKEN_REQUESTED, getAccessTokenSaga),
    takeLatest(types.OKTA_NEW_TOKEN_REQUESTED, getNewAccessTokenSaga),
    takeLatest(types.CREATE_USER_IN_AMP, addUserInAMPSaga),
    takeLatest(types.GET_USER_ONBOARDING_STATUS, getUserOnboardingStatusSaga),
    takeLatest(types.GET_CUSTOM_TOKEN, getCustomAccessTokenSaga),
    takeLatest(types.VALIDATE_USER_IMPERSONATION, validateUserImpersonationSaga),
    takeLatest(types.EXPIRE_GUID, expireGuidSaga),
  ]);
}
